module.exports = __webpack_public_path__ + "img/mini hakkero.0a679031.png";